<template>
  <div style="text-align: center;">
    <h1 :style="'color: ' + this.titleColor" class="pt-6 pb-5">{{ title }}</h1>
    <fin-lexicon-text :style="'color: ' + this.textColor" :text="`${text}`" auto-solve
                      style="font-size: 16px"/>
    <br/>
    <v-btn :color=buttonBackgroundColor
           :dark="buttonDisabled"
           :disabled="buttonDisabled"
           :to="nextTo"
           @click="() => $emit('nextStep')"
           class="my-4"
           style="border-radius: 0;">
      <span :style="'color: ' + this.buttonTextColor" class="px-2">{{ buttonText }}</span>
      <v-icon>icon-arrow-link</v-icon>
    </v-btn>
  </div>
</template>

<script>
import FinLexiconText from '@/components/common/lexicon/LexiconText/index'

export default {
  name: 'finGoToNextStep',
  components: { FinLexiconText },
  props: {
    /** the text displayed as title */
    title: {
      type: String
    },
    /** the text displayed before the button */
    text: {
      type: String
    },
    /** the text displayed in the button */
    buttonText: {
      type: String
    },
    /** the background color */
    backgroundColor: {
      type: String
    },
    /** the color of the title */
    titleColor: {
      type: String
    },
    /** the color of the text displayed before the button */
    textColor: {
      type: String
    },
    /** the color of the button */
    buttonBackgroundColor: {
      type: String
    },
    /** the color of the text in the button */
    buttonTextColor: {
      type: String
    },
    /** disables the next button */
    buttonDisabled: {
      type: Boolean,
      default: false
    },
    /** the height of the row */
    height: {},
    /** navigation target */
    nextTo: {}
  }
}

</script>

<style lang="scss" scoped>
</style>
